export default class FormCache {
  constructor({
    storageName,
    formSeletor,
    parentClassToAdd,
    selfClassToAdd,
    alternativeValueAttribute,
  }) {
    this.storageName = storageName;
    this.form = $(formSeletor);
    this.parentClassToAdd = parentClassToAdd;
    this.selfClassToAdd = selfClassToAdd;
    this.hasLocalStorage = typeof Storage !== "undefined";
    this.formElementsSeletor = "input,select";
    this.alternativeValueAttribute = alternativeValueAttribute;
    this.listen();
  }

  _currentStorage = () => {
    if (!localStorage[this.storageName]) {
      this._setCurrentStorage(JSON.stringify({}));
    }
    return localStorage[this.storageName];
  };

  _setCurrentStorage = (data) => {
    return (localStorage[this.storageName] = data);
  };

  _onChange = (event) => {
    const data = JSON.parse(this._currentStorage());
    const target = event.target;
    data[target.name] = target.value;
    this._setCurrentStorage(JSON.stringify(data));
  };

  listen = () => {
    if (!this.hasLocalStorage) {
      return;
    }
    this.form.find(this.formElementsSeletor).each((key, element) => {
      element = $(element);
      if (!this._shouldDoCache(element)) {
        return;
      }
      element.on("change", this._onChange);
    });
  };

  _shouldDoCache = (element) => {
    return element.attr("formCache") == "true";
  };

  resetForm = () => {
    if (!this.hasLocalStorage) {
      return;
    }
    this.form.each(function (index, element) {
      element.reset();
    });
  };

  fill = () => {
    if (!this.hasLocalStorage) return;

    const data = JSON.parse(this._currentStorage());
    this.form.find(this.formElementsSeletor).each((key, element) => {
      element = $(element);
      if (!this._shouldDoCache(element)) return;

      // Itens já preenchidos pelo render do Rails não serão atribuídos.
      if (element.val() != "" && element.val() != undefined) return;

      let cachedData = data[element.attr("name")];

      if (
        this.alternativeValueAttribute &&
        (cachedData == "" ||
          cachedData == undefined ||
          element.attr("name").includes("telefone"))
      ) {
        cachedData = element.attr(this.alternativeValueAttribute);
      }

      element.val(cachedData);

      if (this.parentClassToAdd) {
        element.parents().addClass(this.parentClassToAdd);
      }

      if (this.selfClassToAdd) element.addClass(this.selfClassToAdd);
    });
  };
}
